import React, { useState } from 'react';
import { Button } from '../../components/Button';
import { Menu, X, PlusCircle } from 'lucide-react';
import './styles.css';

interface MenuAcoesProps {
  onNovoMaterial: () => void;
  onNovoModelo: () => void;
  onNovoUsuario: () => void;
}

export const MenuAcoes: React.FC<MenuAcoesProps> = ({ onNovoMaterial, onNovoModelo, onNovoUsuario }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="menu-acoes-container">
      <Button
        variant="outline"
        className="dashboard-menu-icon"
        onClick={() => setOpen((v) => !v)}
        aria-label="Abrir menu de ações"
        style={{ padding: 8, minWidth: 40 }}
      >
        {open ? <X size={22} /> : <Menu size={22} />}
      </Button>
      {open && (
        <div className="menu-acoes-dropdown">
          <Button
            variant="ghost"
            className="menu-acoes-item"
            onClick={() => { setOpen(false); onNovoMaterial(); }}
          >
            <PlusCircle style={{ marginRight: 8 }} size={18} /> Novo Material
          </Button>
          <Button
            variant="ghost"
            className="menu-acoes-item"
            onClick={() => { setOpen(false); onNovoModelo(); }}
          >
            <PlusCircle style={{ marginRight: 8 }} size={18} /> Novo Modelo
          </Button>
          <Button
            variant="ghost"
            className="menu-acoes-item"
            onClick={() => { setOpen(false); onNovoUsuario(); }}
          >
            <PlusCircle style={{ marginRight: 8 }} size={18} /> Novo Usuário
          </Button>
        </div>
      )}
    </div>
  );
};
